import { ReactNode } from "react";

export type LabelValue = {
  label: string;
  value?: string;
  children?: ReactNode;
};

const LabelValueItem = ({ label, value, children }: LabelValue) => {
  if (!value && !children) return;
  return (
    <div className="flex flex-col gap-1 max-h-[8.5rem] overflow-y-auto">
      <label>{label}</label>
      {children ? children : <span className="text-txtHeading">{value}</span>}
    </div>
  );
};

export default LabelValueItem;
